import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { PhonogramView } from "./PhonogramView";
import { PhonogramViewStore } from "../../store/PhonogramViewStore";
import { useStore } from "../../../../hooks";

export const PhonogramViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/phonogram/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new PhonogramViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            {
              id: "phonogramInfo",
              label: rootStore.langStore.groupPhonogramPhonogramInfoLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <PhonogramView phonogramViewStore={store} />
      </PageLayout>
    </div>
  );
});
